<template>
    <div class="record-directoperation">
        <PageTitle
            icon="fa fa-exchange"
            main="Registro"
            sub="Lançamento com Liquidação direta"
        />
        <b-form>
            <b-row>
                <input
                    id="directoperation-id"
                    type="hidden"
                    v-model="directoperation.id"
                />
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Data de Lançamento:"
                        label-for="directoperation-direct_release_date"
                    >
                        <b-form-input
                            id="directoperation-direct_release_date"
                            type="date"
                            v-model="directoperation.direct_release_date"
                            :readonly="docRead"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Data de Liquidação:"
                        label-for="directoperation-direct_settlement_date"
                    >
                        <b-form-input
                            id="directoperation-direct_settlement_date"
                            type="date"
                            ref="inputsearch"
                            v-model="directoperation.direct_settlement_date"
                            :readonly="docRead"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Nº Ref.:"
                        label-for="directoperation-direct_number"
                    >
                        <b-form-input
                            id="directoperation-direct_number"
                            v-model="directoperation.direct_number"
                            :readonly="docRead"
                            type="number"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Status:"
                        label-for="directoperation-document_status_id"
                    >
                        <b-form-select
                            id="directoperation-document_status_id"
                            size="sm"
                            disabled
                            :options="documentstatus"
                            v-model="directoperation.document_status_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Conta Banco/Caixa:"
                        label-for="directoperation-entity_settlement_id"
                    >
                        <b-form-select
                            id="directoperation-entity_settlement_id"
                            @input="loadEntitySettlements"
                            size="sm"
                            :disabled="docRead"
                            :options="entitysettlements"
                            v-model="directoperation.entity_settlement_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Valor:"
                        label-for="directoperation-diretc_release_value"
                    >
                        <b-form-input
                            id="directoperation-diretc_release_value"
                            v-model="directoperation.diretc_release_value"
                            type="number"
                            size="sm"
                            :readonly="true"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Operação:"
                        label-for="directoperation-operation_direct_id"
                    >
                        <b-form-select
                            id="directoperation-operation_direct_id"
                            :disabled="docRead"
                            size="sm"
                            @input="loadOperationsLevelOnes"
                            :options="operations"
                            v-model="directoperation.operation_direct_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="10" sm="12">
                    <b-form-group
                        label="Observação:"
                        label-for="directoperation-comments"
                    >
                        <b-form-textarea
                            id="directoperation-comments"
                            :rows="2"
                            :max-rows="6"
                            size="sm"
                            :readonly="docRead"
                            v-model="directoperation.comments"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    v-show="!docRead"
                    class="fa fa-save"
                    @click="saveDirectOperation"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="ml-2 fa fa-reply"
                    @click="goback"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="ml-2"
                    v-if="
                        this.directoperation.document_status_id === 1 &&
                            directoperation.id > 0 &&
                            directoperation.diretc_release_value > 0
                    "
                    @click=";[confirmDirectOperation()]"
                    >Confirmar</b-button
                >
            </b-col>
        </b-row>
        <hr />
        <b-card bg-variant="light" text-variant="dark">
            <b-tabs pills card small>
                <b-tab title="Lançamento(s)" active>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-button
                                title="Adicionar Lançamento"
                                size="sm"
                                @click="setNewRelease"
                                v-b-modal.modalDirectOperationRelease
                                v-show="
                                    this.directoperation.document_status_id ===
                                        1 && this.directoperation.id > 0
                                        ? true
                                        : false
                                "
                                variant="light"
                                class="mr-2 mb-2 fa fa-plus"
                            >
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12">
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    hover
                                    key="slide"
                                    head-variant="light"
                                    :items="directoperationsreleases"
                                    :fields="fieldsDirectOperationRelease"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Editar registro"
                                            v-show="!docRead"
                                            v-b-modal.modalDirectOperationRelease
                                            size="sm"
                                            variant="light"
                                            @click="
                                                loadDirectOperationsRelease(
                                                    data.item
                                                )
                                            "
                                            class="mr-2 mt-2 fa fa-pencil"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            v-show="!docRead"
                                            variant="light"
                                            @click="modeRelease = 'remove'"
                                            class="mr-2 mt-2 fa fa-trash"
                                            v-if="modeRelease === 'insert'"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeRelease(data.item),
                                                    (modeRelease = 'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2 fa fa-check"
                                            v-if="modeRelease === 'remove'"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="modeRelease = 'insert'"
                                            class="mr-2 mt-2 fa fa-times"
                                            v-if="modeRelease === 'remove'"
                                        >
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="modeRelease === 'remove'"
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Classificação">
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-button
                                title="Adicionar"
                                size="sm"
                                @click="setNewApportionment"
                                v-b-modal.modalDirectOperationApportionment
                                v-show="
                                    this.directoperation.document_status_id ===
                                        1 && this.directoperation.id > 0
                                        ? true
                                        : false
                                "
                                variant="light"
                                class="mr-2 mb-2"
                            >
                                <i class="fa fa-plus"></i
                            ></b-button>
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    sticky-header
                                    head-variant="light"
                                    hover
                                    key="slide"
                                    :items="directoperationsapportionments"
                                    :fields="fieldsApportionment"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Editar registro"
                                            v-b-modal.modalDirectOperationApportionment
                                            size="sm"
                                            variant="light"
                                            @click="
                                                loadDirectOperationsApportionment(
                                                    data.item
                                                )
                                            "
                                            class="mr-2 mt-2 fa fa-pencil"
                                        >
                                        </b-button>
                                        <b-button
                                            title="Excluir registro"
                                            size="sm"
                                            variant="light"
                                            @click="
                                                modeApportionment = 'remove'
                                            "
                                            v-if="
                                                modeApportionment === 'insert'
                                            "
                                            class="mr-2 mt-2 fa fa-trash"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeApportionment(
                                                        data.item
                                                    ),
                                                    (modeApportionment =
                                                        'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2 fa fa-check"
                                            v-if="
                                                modeApportionment === 'remove'
                                            "
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                modeApportionment = 'insert'
                                            "
                                            class="mr-2 mt-2"
                                            v-if="
                                                modeApportionment === 'remove'
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="
                                                modeApportionment === 'remove'
                                            "
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-card>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
        <b-modal
            id="modalDirectOperationRelease"
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Lançamento(s)"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveRelease"
        >
            <b-form>
                <b-row>
                    <b-col md="2" sm="2">
                        <b-form-group label="ID" label-for="entity-id">
                            <b-form-input
                                id="entity-id"
                                type="text"
                                v-model="directoperationsrelease.entity_id"
                                @input="
                                    setEntity(directoperationsrelease.entity_id)
                                "
                                @change="
                                    setEntity(directoperationsrelease.entity_id)
                                "
                                v-on:keyup.alt.enter="openModalEntity"
                                size="sm"
                                :state="entityState"
                                placeholder="Código..."
                            />
                            <b-form-invalid-feedback id="input-live-entity_id">
                                Falta Informar...
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-link v-b-modal.modalEntity class="fa fa-search mt-4">
                    </b-link>
                    <b-col md="5" sm="8">
                        <b-form-group
                            label="Nome/Razão Social:"
                            label-for="entity-name_entity"
                        >
                            <b-form-input
                                id="entity-name_entity"
                                type="text"
                                v-model="entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ:"
                            label-for="entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entity-cnpj_cpf"
                                type="text"
                                v-model="entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        v-b-modal.modalRegisterEntity
                        class="fa fa-plus mt-4"
                    >
                    </b-link>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Tipo de Documento:"
                            label-for="directoperationsrelease-type_document_id"
                        >
                            <b-form-select
                                id="directoperationsrelease-type_document_id"
                                @input="loadSeries()"
                                size="sm"
                                :state="typeDocumentState"
                                :options="typedocuments"
                                v-model="
                                    directoperationsrelease.type_document_id
                                "
                            />
                            <b-form-invalid-feedback
                                id="input-live-type_document_id"
                            >
                                Falta Informar o Tipo do documento...
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col md="1" sm="12">
                        <b-form-group
                            label="Série:"
                            label-for="directoperationsrelease-serie_type_document_id"
                        >
                            <b-form-select
                                id="directoperationsrelease-serie_type_document_id"
                                size="sm"
                                :disabled="docRead"
                                :options="series"
                                v-model="
                                    directoperationsrelease.serie_type_document_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Data de Emissão:"
                            label-for="directoperationsrelease-issue_date"
                        >
                            <b-form-input
                                id="directoperationsrelease-issue_date"
                                type="date"
                                v-model="directoperationsrelease.issue_date"
                                size="sm"
                                :state="issueDateState"
                            />
                            <b-form-invalid-feedback id="input-live-issue_date">
                                Falta Informar Data Emissão...
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Nº de Lançamento:"
                            label-for="directoperationsrelease-number_release"
                        >
                            <b-form-input
                                id="directoperationsrelease-number_release"
                                v-model="directoperationsrelease.number_release"
                                type="number"
                                size="sm"
                                :state="releaseNumberState"
                            />
                            <b-form-invalid-feedback
                                id="input-live-release_number"
                            >
                                Falta Informar o número do lançamento...
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="directoperationsrelease-operation_value"
                        >
                            <b-form-input
                                id="directoperationsrelease-operation_value"
                                v-model="
                                    directoperationsrelease.operation_value
                                "
                                type="number"
                                :state="releaseValueState"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                            <b-form-invalid-feedback
                                id="input-live-operation_value"
                            >
                                Falta Informar o Valor do Lançamento...
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Observação:"
                            label-for="directoperationsrelease-comments"
                        >
                            <b-form-textarea
                                id="directoperationsrelease-comments"
                                :rows="2"
                                :max-rows="6"
                                size="sm"
                                v-model="directoperationsrelease.comments"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalDirectOperationApportionment"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Rateio(s)"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveApportionment"
        >
            <b-form>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Tipo:"
                            label-for="directoperationsapportionment-apportionment_type_cost_id"
                        >
                            <b-form-select
                                id="directoperationsapportionment-apportionment_type_cost_id"
                                size="sm"
                                :options="typecosts"
                                v-model="
                                    directoperationsapportionment.apportionment_type_cost_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="1º Nível:"
                            label-for="directoperationsapportionment-apportionment_operation_level_one_id"
                        >
                            <b-form-select
                                id="directoperationsapportionment-apportionment_operation_level_one_id"
                                @input="loadOperationsLevelTwos"
                                size="sm"
                                :options="operationslevelones"
                                v-model="
                                    directoperationsapportionment.apportionment_operation_level_one_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="2º Nível:"
                            label-for="directoperationsapportionment-apportionment_operation_level_two_id"
                        >
                            <b-form-select
                                id="directoperationsapportionment-apportionment_operation_level_two_id"
                                size="sm"
                                :options="operationsleveltwos"
                                v-model="
                                    directoperationsapportionment.apportionment_operation_level_two_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="7" sm="12">
                        <b-form-group
                            label="Centro Resultado:"
                            label-for="directoperationsapportionment-apportionment_cost_center_id"
                        >
                            <b-form-select
                                id="directoperationsapportionment-apportionment_cost_center_id"
                                size="sm"
                                :options="costcenters"
                                v-model="
                                    directoperationsapportionment.apportionment_cost_center_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="%:"
                            label-for="directoperationsapportionment-apportionment_percent"
                        >
                            <b-form-input
                                id="directoperationsapportionment-apportionment_percent"
                                v-model="
                                    directoperationsapportionment.apportionment_percent
                                "
                                type="number"
                                size="sm"
                                @input="apportionmentValue"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="directoperationsapportionment-apportionment_value"
                        >
                            <b-form-input
                                id="directoperationsapportionment-apportionment_value"
                                v-model="
                                    directoperationsapportionment.apportionment_value
                                "
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl, showError } from '@/global'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
import axios from 'axios'
var moment = require('moment')

export default {
    name: 'RecordDirectOperation',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'save',
            modeRelease: 'insert',
            modeApportionment: 'insert',
            docRead: false,
            showRelease: false,
            showEntity: false,
            entity_id: null,
            search: '',
            searchEntity: '',
            documentstatus: [],
            directoperation: {},
            directoperationsrelease: {},
            directoperationsapportionment: {},
            typedocumentssequencenumber: {},
            directoperationsapportionments: [],
            directoperationsreleases: [],
            entity: {},
            entitys: [],
            costcenters: [],
            operations: [],
            operationsleveltwos: [],
            operationslevelones: [],
            typecosts: [],
            entitysettlements: [],
            typedocuments: [],
            series: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            perPage: 5,
            currentPage: 1,
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'fantasy_name', label: 'Nome Fantasia', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsDirectOperationRelease: [
                {
                    key: 'issue_date',
                    label: 'Data Emissão',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                { key: 'name_reduced', label: 'Tipo Doc.', sortable: false },
                { key: 'number_release', label: 'Nº.', sortable: false },
                {
                    key: 'operation_value',
                    label: 'Valor',
                    sortable: false,
                    variant: 'secondary'
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsApportionment: [
                {
                    key: 'name_cost_center',
                    label: 'Centro Resultado',
                    sortable: false
                },
                { key: 'name_type_cost', label: 'Tipo', sortable: false },
                {
                    key: 'name_operation_level_two',
                    label: 'Operação',
                    sortable: false
                },
                { key: 'apportionment_percent', label: '%', sortable: false },
                { key: 'apportionment_value', label: 'Valor', sortable: false },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
    computed: {
        issueDateState() {
            return this.directoperationsrelease.issue_date ? true : false
        },
        releaseNumberState() {
            return this.directoperationsrelease.number_release > 0
                ? true
                : false
        },
        typeDocumentState() {
            return this.directoperationsrelease.type_document_id ? true : false
        },
        costCenterState() {
            return this.directoperationsrelease.cost_center_id ? true : false
        },
        releaseValueState() {
            return this.directoperationsrelease.operation_value > 0
                ? true
                : false
        },
        typeCostState() {
            return this.directoperationsrelease.type_cost_id ? true : false
        },
        operationState() {
            return this.directoperationsrelease.operation_id ? true : false
        },
        operationLevelOneState() {
            return this.directoperationsrelease.operation_level_one_id
                ? true
                : false
        },
        operationLevelTwoState() {
            return this.directoperationsrelease.operation_level_two_id
                ? true
                : false
        },
        entityState() {
            return this.directoperationsrelease.entity_id ? true : false
        },
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredList() {
            return this.entitys.filter(entity => {
                return (
                    entity.name_entity
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase()) ||
                    entity.cnpj_cpf
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase())
                )
            })
        },
        rows() {
            return this.entitys.length
        }
    },
    methods: {
        apportionmentValue() {
            return (this.directoperationsapportionment.apportionment_value = parseFloat(
                this.directoperation.diretc_release_value *
                    ((this.directoperationsapportionment.apportionment_percent
                        ? this.directoperationsapportionment
                              .apportionment_percent
                        : 0) /
                        100)
            ).toFixed(2))
        },
        goback() {
            this.$router.go(-1, { query: 'q=s', hash: 'hashFrag' })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        loadEntitys() {
            const url = `${baseApiUrl}/entitys`
            axios.get(url).then(res => {
                this.entitys = res.data
            })
        },
        async loadDirectOperationsReleases() {
            const id = this.directoperation.id
            const url = `${baseApiUrl}/directoperationsreleases/${id}/directoperation`
            await axios.get(url).then(res => {
                this.directoperationsreleases = res.data
            })
        },
        async loadDirectOperationsApportionments() {
            const id = this.directoperation.id
            const url = `${baseApiUrl}/directoperationsapportionments/${id}/directoperation`
            await axios.get(url).then(res => {
                this.directoperationsapportionments = res.data
            })
        },
        async saveDirectOperation() {
            if (this.directoperation.id) {
                this.directoperation.user_update_id = this.user.id
                this.directoperation.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.directoperation.user_id = this.user.id
                if (!this.compan) {
                    this.$toasted.global
                        .defaultError({ msg: 'Logar na Empresa' })
                        .catch(showError)
                } else {
                    this.directoperation.company_id = this.compan.id
                }
            }
            const method = this.directoperation.id ? 'put' : 'post'
            const id = this.directoperation.id
                ? `/${this.directoperation.id}`
                : ''
            await axios[method](
                `${baseApiUrl}/directoperations${id}`,
                this.directoperation
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.getLastDirectOperation()
                    await this.loadDirectOperation()
                })
                .catch(showError)
        },
        async getLastDirectOperation() {
            const url = `${baseApiUrl}/directoperationidlast/${this.directoperation.company_id}/?user_id=${this.directoperation.user_id}/&entity_settlement_id=${this.directoperation.entity_settlement_id}`
            await axios(url).then(
                res => (this.directoperation.id = res.data.id)
            )
        },
        async loadTotalDirectOperations() {
            const url = `${baseApiUrl}/directoperationidtotal/${this.directoperation.id}`
            await axios.get(url).then(res => {
                this.directoperation.diretc_release_value = res.data[0].total
            })
        },
        async confirmDirectOperation() {
            if (!this.compan.accounting_period_start) {
                this.$toasted.global.defaultError({
                    msg: 'Empresa sem definição de Período Contábil'
                })
            } else {
                if (
                    this.formatDate(this.compan.accounting_period_start) >
                    this.formatDate(this.directoperation.direct_settlement_date)
                ) {
                    this.$toasted.global.defaultError({
                        msg: 'Data esta fora do período contábil'
                    })
                } else if (
                    this.formatDate(this.compan.accounting_period_end) <
                    this.formatDate(this.directoperation.direct_settlement_date)
                ) {
                    this.$toasted.global.defaultError({
                        msg: 'Data esta fora do período contábil'
                    })
                } else {
                    if (this.directoperation.id) {
                        if (this.directoperation.document_status_id === 2) {
                            this.directoperation.document_status_id = 1
                            this.docRead = false
                        } else {
                            this.directoperation.document_status_id = 2
                            this.docRead = true
                        }
                        this.directoperation.user_update_id = this.user.id
                        this.directoperation.update_date = this.formatDate(
                            moment.utc().local()
                        )

                        const method = this.directoperation.id ? 'put' : 'post'
                        const id = this.directoperation.id
                            ? `/${this.directoperation.id}`
                            : ''
                        await axios[method](
                            `${baseApiUrl}/directoperations${id}`,
                            this.directoperation
                        )
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                if (
                                    this.directoperation.document_status_id ===
                                    2
                                ) {
                                    this.goback()
                                }
                            })
                            .catch(showError)
                    }
                }
            }
        },
        async saveTotalRelease() {
            const method = 'put'
            await axios[method](
                `${baseApiUrl}/directoperationtotal/${this.directoperation.id}`
            )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },
        async saveRelease() {
            if (this.directoperationsrelease.id) {
                this.directoperationsrelease.user_update_id = this.user.id
                this.directoperationsrelease.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.directoperationsrelease.user_id = this.user.id
            }

            const method = this.directoperationsrelease.id ? 'put' : 'post'
            const id = this.directoperationsrelease.id
                ? `/${this.directoperationsrelease.id}`
                : ''
            this.directoperationsrelease.direct_operation_id = this.directoperation.id
            await axios[method](
                `${baseApiUrl}/directoperationsreleases${id}`,
                this.directoperationsrelease
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.directoperationsrelease = {}
                    await this.saveTotalRelease()
                    await this.loadTotalDirectOperations()
                    await this.loadDirectOperationsReleases()
                })
                .catch(showError)
        },
        async saveApportionment() {
            if (this.directoperationsapportionment.id) {
                this.directoperationsapportionment.user_update_id = this.user.id
                this.directoperationsapportionment.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.directoperationsapportionment.user_id = this.user.id
            }

            const method = this.directoperationsapportionment.id
                ? 'put'
                : 'post'
            const id = this.directoperationsapportionment.id
                ? `/${this.directoperationsrelease.id}`
                : ''
            this.directoperationsapportionment.apportionment_direct_operation_id = this.directoperation.id
            this.directoperationsapportionment.apportionment_operation_id = this.directoperation.operation_direct_id
            await axios[method](
                `${baseApiUrl}/directoperationsapportionments${id}`,
                this.directoperationsapportionment
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.directoperationsapportionment = {}
                    await this.loadDirectOperationsApportionments()
                })
                .catch(showError)
        },
        async removeRelease(directoperationsrelease) {
            const id = directoperationsrelease.id
            await axios
                .delete(`${baseApiUrl}/directoperationsreleases/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadDirectOperationsReleases()
                })
                .catch(showError)
        },
        async removeApportionment(directoperationsapportionment) {
            const id = directoperationsapportionment.id
            await axios
                .delete(`${baseApiUrl}/directoperationsapportionments/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadDirectOperationsApportionments()
                })
                .catch(showError)
        },
        async setEntity(entity) {
            if (!this.directoperationsrelease.entity_id) {
                this.directoperationsrelease.entity_id = entity.id
            }
            const url = `${baseApiUrl}/entitys/${this.directoperationsrelease.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        setSearchEntity() {
            this.directoperationsrelease = {
                ...this.directoperationsrelease,
                entity_id: this.entity_id
            }
        },
        async loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            await axios.get(url).then(res => {
                this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                })
            })
            this.$refs.inputsearch.focus()
        },
        async loadCostCenter() {
            if (this.compan) {
                const url = `${baseApiUrl}/costcenteranalitic/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.costcenters = res.data.map(costcenter => {
                        return {
                            value: costcenter.id,
                            text: costcenter.name_cost_center
                        }
                    })
                })
            }
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status
                    }
                })
            })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.directoperation.operation_direct_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.directoperationsapportionment.apportionment_operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        setNewRelease() {
            this.directoperationsrelease = {}
            this.entity = {}
            const date = new Date()
            this.directoperationsrelease.issue_date = moment
                .utc(date)
                .local()
                .format('YYYY-MM-DD')
            this.directoperationsrelease.operation_id = this.directoperation.operation_direct_id
            this.loadOperationsLevelOnes()
        },
        setNewApportionment() {
            this.directoperationsapportionment = {}
        },
        loadDirectOperationsRelease(release) {
            this.directoperationsrelease = { ...release }
            this.entity.name_entity = this.directoperationsrelease.name_entity
            this.entity.cnpj_cpf = this.directoperationsrelease.cnpj_cpf
        },
        async loadDirectOperationsApportionment(apportment) {
            this.directoperationsapportionment = { ...apportment }
        },
        async loadDirectOperation() {
            const url = `${baseApiUrl}/directoperations/${this.directoperation.id}`
            await axios.get(url).then(res => {
                this.directoperation = { ...res.data }
                this.directoperation.direct_release_date = this.formatDate(
                    this.directoperation.direct_release_date
                )
                this.directoperation.direct_settlement_date = this.formatDate(
                    this.directoperation.direct_settlement_date
                )
            })
        },
        async loadTypeDocument() {
            const url = `${baseApiUrl}/typedocuments`
            await axios.get(url).then(res => {
                this.typedocuments = res.data.map(typedocument => {
                    return {
                        value: typedocument.id,
                        text: typedocument.name_reduced
                    }
                })
            })
        },
        async loadEntitySettlements() {
            const url = `${baseApiUrl}/entitysettement/${this.compan.id}`
            await axios.get(url).then(res => {
                this.entitysettlements = res.data.map(entitysettlement => {
                    return {
                        value: entitysettlement.id,
                        text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`
                    }
                })
            })
        },
        async loadSeries() {
            const url = `${baseApiUrl}/series/${this.directoperationsrelease.type_document_id}/typedocuments`
            await axios.get(url).then(res => {
                this.series = res.data.map(serie => {
                    return { value: serie.id, text: serie.serie }
                })
            })
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        }
    },
    watch: {
        $route(to) {
            //this.directoperation = to.params
            this.directoperation = to.query.directoperationbase

            //this.loadDirectOperationbase()
        }
    },
    async mounted() {
        if (!this.$route.query.directoperationbase) {
            this.directoperation.id = this.$route.params.id
            await this.loadDirectOperation()
        } else {
            this.directoperation = this.$route.query.directoperationbase
            this.docRead =
                this.directoperation.document_status_id === 1 ? false : true
        }

        if (!this.directoperation.direct_release_date) {
            this.directoperation.direct_release_date = moment
                .utc()
                .local()
                .format('YYYY-MM-DD')
            this.directoperation.direct_settlement_date = moment
                .utc()
                .local()
                .format('YYYY-MM-DD')
        }

        this.loadTypeCost()
        this.loadCostCenter()
        this.loadOperation()
        this.loadDirectOperationsReleases()
        this.loadDirectOperationsApportionments()
        this.loadDocumentStaus()
        this.loadEntitySettlements()
        this.loadTypeDocument()
        this.loadOperationsLevelOnes()
    }
}
</script>

<style>
.record-directoperation select,
label {
    font-size: 0.7rem;
}
.record-directoperation input {
    font-size: 0.7rem;
}
.record-directoperation button {
    font-size: 0.7rem;
}
.record-directoperation h6 {
    font-size: 0.7rem;
}

#modalDirectOperationRelease select,
label {
    font-size: 0.7rem;
}

#modalDirectOperationRelease input {
    font-size: 0.7rem;
}

#modalDirectOperationRelease button {
    font-size: 0.7rem;
}

#modalDirectOperationApportionment select,
label {
    font-size: 0.7rem;
}

#modalDirectOperationApportionment input {
    font-size: 0.7rem;
}

#modalDirectOperationApportionment button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
